import url from '../../../../url.js';
export default {
    name: "News",
    data() {
        return {
            title: 'Berita Terkini',
            dataNews: [],
            selectedNews: {
                title: '',
                content: '',
                news: '',
                created_on: '',
            },
            ApiUrl: url.API_URL,
            gambarUrl: url.IMAGE + 'news/'
        }
    },
    methods: {
        async fetchData() {
            const response = await fetch(this.ApiUrl + 'm147_news/id/2');
            const data = await response.json();
            this.dataNews = data;
        },
        showNews(newsId) {
            const news = this.dataNews.find(item => item.id === newsId);
            if (news) {
                this.selectedNews = {
                    title: news.title,
                    content: news.content,
                    news: news.news,
                    created_on: news.created_on,
                }
            }
        }
    },
    mounted(){
        this.fetchData();
    }
}